import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { throwError } from 'rxjs/internal/observable/throwError';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import {LoginServerService} from "src/app/layouts/public/login/services/login-server.service";
import { Router } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { finalize } from 'rxjs/internal/operators/finalize';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/internal/operators/take';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {

  private isTokenRefreshing = false;

  private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private acct: LoginServerService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the user is logging in for the first time
    return next.handle(this.attachTokenToRequest(request)).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
        }
      }),
      catchError((err): Observable<any> => {
        if (request.url.toLowerCase().includes("refreshtoken/login")) {

          // logout user
          return this.redirectUserToPortal();
        }

        if (err instanceof HttpErrorResponse) {
          switch ((err as HttpErrorResponse).status) {
            case 401:
              return this.handleHttpResponseError(request, next);
          }
        } else {
          return throwError(() => err);
        }

        return throwError(() => err);
      })

    );

  }

  private redirectUserToPortal() {
    console.log("Redirecting to portal. Logging out");
    const result = this.acct.accountLogout();

    this.router.navigate(['/']);
    return result;
  }

  // Global error handler method 
  private handleError(errorResponse: HttpErrorResponse) {
    let errorMsg: string;

    if (errorResponse.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMsg = "An error occured : " + errorResponse.error.message;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMsg = `Backend returned code ${errorResponse.status}, body was: ${errorResponse.error}`;
    }

    return throwError(errorMsg);
  }
  // Method to handle http error response
  private handleHttpResponseError(request: HttpRequest<any>, next: HttpHandler) {

    // First thing to check if the token is in process of refreshing
    if (!this.isTokenRefreshing && !this.acct.loginRunning)  // If the Token Refresheing is not true
    {
      this.isTokenRefreshing = true;

      // Any existing value is set to null
      // Reset here so that the following requests wait until the token comes back from the refresh token API call
      this.tokenSubject.next(null);
      
      console.log("401 detected, refreshing token...");

      /// call the API to refresh the token
      return this.acct.getNewRefreshToken().pipe(
        switchMap((tokenresponse) => {

          if (tokenresponse) {
            this.tokenSubject.next(tokenresponse.token);

            return next.handle(this.attachTokenToRequest(request));
          }

          return this.redirectUserToPortal();
        }),
        catchError(err => {
          console.log("Refresh token failed, logging out user.");
          if (err instanceof HttpErrorResponse) {
            switch ((err as HttpErrorResponse).status) {
              case 401:
                // logged out goto home (login page)
                return this.redirectUserToPortal();
            }
          }

          return this.handleError(err);
        }),
        finalize(() => {
          this.isTokenRefreshing = false;
        })
      );

    }
    else {
      //this.isTokenRefreshing = false;
      return this.tokenSubject.pipe(filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.attachTokenToRequest(request));
        }));
    }


  }


  private attachTokenToRequest(request: HttpRequest<any>) {
    const token = localStorage.getItem('jwt');

      //console.log("Adding bearer token: " + token);

      // do not add bearer token to the request if the url is to blob storage
      if (request.url.indexOf("blob.core.windows.net") != -1) {
          return request;
      }

    // DM - 2020-05-12 - added Cache control to request headers (from Client app)
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00: 00: 00 GMT'
      }
    });
  }
}
